import { noteIncomingPrepareActive } from "@/lib/mail/mailNotificationSoundGate";

/** Signal : nouveaux mails masqués jusqu’à corps prêt (journal / son — plus de barre header). */
export const MAIL_INCOMING_PREPARE_EVENT = "mailIncomingPrepare";

export type MailIncomingPreparePhase = "headers" | "body";

export type MailIncomingPrepareDetail = {
  count: number;
  /** En-têtes/objet reçus → puis corps. */
  phase: MailIncomingPreparePhase;
};

let lastPrepareCount = 0;

export function getIncomingPrepareCount(): number {
  return lastPrepareCount;
}

export function notifyIncomingPrepare(
  count: number,
  phase: MailIncomingPreparePhase = "body"
): void {
  const next = Math.max(0, count);
  lastPrepareCount = next;
  noteIncomingPrepareActive(next > 0);
  window.dispatchEvent(
    new CustomEvent<MailIncomingPrepareDetail>(MAIL_INCOMING_PREPARE_EVENT, {
      detail: {
        count: next,
        phase: next > 0 ? phase : "body",
      },
    })
  );
}
